export const CRUNCHBASE_COMPANY_ATTEMPT = "CRUNCHBASE_COMPANY_ATTEMPT";
export const crunchbaseCompanyAttempt = (payload) => ({
  type: CRUNCHBASE_COMPANY_ATTEMPT,
  payload,
});
